import { useTheme } from '@mui/material/styles';
import { Box, Stack, Typography } from '@mui/material';

import useAuth from 'hooks/useAuth';

// ==============================|| SIGNED-IN PANEL ||============================== //

// "Where am I" block for dead-end pages: the active org, the account, and how
// many clinics it can reach. The org name is what lets a user with a stale
// bookmark from another org recognise the mistake.
const SignedInPanel = () => {
    const theme = useTheme();
    const { organizationMeta, email, clinicGrants } = useAuth();

    const orgName = organizationMeta?.meta?.name || 'this organization';
    const clinicCount = Object.keys(clinicGrants || {}).length;
    const clinicsLabel = clinicCount === 1 ? '1 available' : `${clinicCount} available`;

    return (
        <Box
            data-testid="signed-in-panel"
            sx={{
                borderRadius: '10px',
                padding: 2,
                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.grey[100]
            }}
        >
            <Stack spacing={1.25}>
                <Typography
                    variant="caption"
                    sx={{ textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700 }}
                    color="text.secondary"
                >
                    You&apos;re signed in to
                </Typography>
                <Typography variant="h4">{orgName}</Typography>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 1.5, rowGap: 0.25 }}>
                    <Typography variant="body2" color="text.secondary">
                        As
                    </Typography>
                    <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
                        {email}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Clinics
                    </Typography>
                    <Typography variant="body2">{clinicsLabel}</Typography>
                </Box>
            </Stack>
        </Box>
    );
};

export default SignedInPanel;
